module.exports = __webpack_public_path__ + "static/media/pl-openrfp.96220416.svg";